module.exports = __webpack_public_path__ + "img/img-main-bg00.626f3cc0.png";